import React from 'react';
import { connect } from 'react-redux';

import { fetchReports } from 'ducks/reports';
import Row from 'components/UIKit/Flex/Row';
import Column from 'components/UIKit/Flex/Column';
import Card from 'components/UIKit/Card';
import Button from 'components/UIKit/Button/ButtonTemplate';

let POReports = ({ dispatch, projects }) => (
  <Card title="reports">
    <Column>
      <Row>
        Project Summary Reports are provided to give a detailed overview of the status
        of all active submission projects in the GDC.   Updates to reports
        are made only once per day so may not reflect the status of a
        project in real time.
      </Row>
      <Row style={{ marginTop: '1rem' }}>
        <Column style={{ width: '17rem' }}>
          <Row style={{ alignItems: 'center' }}>
            <Button
              data-testid="button-case-overview"
              style={{ width: '14.2rem' }}
              PrefixComponent={
                <i
                  className="material-icons"
                  style={{ fontSize: '1.4rem', marginRight: '0.6rem' }}
                >
                  file_download
                </i>
              }
              onClick={
                () => {
                  dispatch(fetchReports({ reportType: 'case_overview', projects }, { download: true }));
                }
              }
            >
              Case Overview
            </Button>
          </Row>
          <Row style={{ marginTop: `1rem`, alignItems: 'center' }}>
            <Button
              data-testid="button-aliquot-overview"
              style={{ width: '14.2rem' }}
              PrefixComponent={
                <i
                  className="material-icons"
                  style={{ fontSize: '1.4rem', marginRight: '0.6rem' }}
                >
                  file_download
                </i>
              }
              onClick={
                () => {
                  dispatch(fetchReports({ reportType: 'aliquot_overview', projects }, { download: true }));
                }
              }
            >
              Aliquot Overview
            </Button>
          </Row>
          <Row style={{ marginTop: `1rem`, alignItems: 'center' }}>
            <Button
              data-testid="button-data-overview"
              style={{ width: '14.2rem' }}
              PrefixComponent={
                <i
                  className="material-icons"
                  style={{ fontSize: '1.4rem', marginRight: '0.6rem' }}
                >
                  file_download
                </i>
              }
              onClick={
                () => {
                  dispatch(fetchReports({ reportType: 'data_validation', projects }, { download: true }));
                }
              }
            >
              Data Validation
            </Button>
          </Row>
        </Column>
        <Column>
          <Row>
            Provides the number of cases uploaded broken down by those
            with clinical, biospecimen, and submittable data files.
          </Row>
          <Row style={{ marginTop: `1rem` }}>
            Provides the number of aliquots with data files, broken down
            by sample tissue type.
          </Row>
          <Row style={{ marginTop: `1rem` }}>
            Provides the number of submittable data files uploaded, broken
            down by file status.
          </Row>
        </Column>
      </Row>
    </Column>
  </Card>
);

export default connect()(POReports);
